/** @format */

export interface Ga4UserContextInput {
  isAuthenticated?: boolean;
  uuid?: string | null;
}

export interface Ga4UserContext {
  user_status: 'logged_in' | 'logged_out';
  user_id?: string;
}

export function getGa4UserContext({ isAuthenticated = false, uuid }: Ga4UserContextInput = {}): Ga4UserContext {
  if (!isAuthenticated) {
    return { user_status: 'logged_out' };
  }

  const context: Ga4UserContext = { user_status: 'logged_in' };

  if (uuid !== undefined && uuid !== null && String(uuid).trim() !== '') {
    context.user_id = String(uuid);
  }

  return context;
}
